import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper';


export default {
  name: 'UpdateShipmentDetails',
  components: {
      VueElementLoading,
      Treeselect,
      Paginate,
  },
  mixins:[PageTracker],
  data: function() {
      return {
          picked : "single",
          disabled : 0,
          disabledHub : 1,
          Parentmps : '',
          comments : '',
          txtShipment : '',
          AWBType : '',
          ddlHub : '',
          getHubObj : '',
          txtShipmentId : '',
          shipDetails :{
            ShippingComments : '',
            ShippingPincode : '',
            mobileno : '',
            ShippingState : '',
            ShippingCity : '',
            shippingAddress : '',
          },
          newRTOStateObj : [{"StateID" : "1","Name" : "MH"}],
          newRTOCityObj : [{"CityID" : '1',"Name":"Pune"}],
          reasonObj : [{"ReasonsID" : "1","Reason":"change shipment status"},{"ReasonsID" : "2","Reason":"change shipment RTOToHub status"}],
          shipdetailsFlag : false,
          AWBTypeObj : [{"id":"Cargo","type":"Cargo AWB NO "},{"id":"PortToPort","type":"Port to Port AWB NO"}],
      }
  },
  created: function() {
      this.getHubList();
      this.getState();
  },
  async mounted(){
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,

    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods : {
    getState(){
     axios.get(apiUrl.api_url + 'getstate/list', {})
      .then((response) => {
          if(response.data.code===200){
              this.newRTOStateObj =response.data.data;
              //console.log("this.StateObj",this.StateObj);
          }
          else {
              this.newRTOStateObj=[];
          }
      })
      .catch((httpException) => {
          this.$alertify.error("State data not found");
          console.error('exception is:::::::::', httpException)
      })
    },
    getCity(){
      let stateId = this.shipDetails.ShippingState.toString();
      axios.post(apiUrl.api_url + 'city/list', {"stateId":stateId})
       .then((response) => {
           if(response.data.code===200){
               this.newRTOCityObj =response.data.data;
               console.log('this.CityObj : ',this.newRTOCityObj);
           }
           else {
               this.newRTOCityObj=[];
           }
       })
       .catch((httpException) => {
           this.$alertify.error("City data not found");
           console.error('exception is:::::::::', httpException)
       })
   },

    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');

          var ParentMPS = {
              parentmps : this.Parentmps,
          }
          console.log('Payload 1: ',ParentMPS);
          this.shipDetails = {
            "shippingAddress" : 'Pune',
            "ShippingCity" : '',
            "ShippingState" : '',
            "mobileno" : '8888888888',
            "ShippingPincode": '411001',
            "ShippingComments" : '',
          }
          this.shipdetailsFlag = true;

        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm1(scope) {
      console.log('form2');
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');

          var updateDestination = {
              awbtype : this.AWBType,
              shippingid : this.txtShipment,
              hubid : this.ddlHub,
              comments : this.comments
          }
          console.log('Payload 2: ',updateDestination);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm3(scope) {
      console.log('form3');
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');

          var updateshippingDetails = {
              address : this.shipDetails.shippingAddress,
              city : this.shipDetails.ShippingCity,
              state : this.shipDetails.ShippingState,
              mobile : this.shipDetails.mobileno,
              pincode : this.shipDetails.ShippingPincode,
              comments : this.shipDetails.ShippingComments
          }
          console.log('Payload 3: ',updateshippingDetails);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){

       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.getHubObj =response.data.data;
            }
            else {
                this.getHubObj=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.success("hub data not found");
            console.error('exception is:::::::::', httpException)
        })

    },
    clear(){
      this.disabled = 0;
      this.disabledHub = 1;
      this.txtShipment = '';
      this.ddlHub = '';
      this.comments = '';
      this.AWBType = '',
      this.Parentmps = '',
      this.shipDetails = {},
      this.shipdetailsFlag = false;
      this.$validator.reset();
      this.errors.clear();
    },
    show(){
      console.log('show');
      if(this.txtShipment != ''){
        this.disabled = 1;
        this.disabledHub = 0;
      }
    },
    AwbType(){
      console.log('changed');
      this.disabled = 0;
      this.disabledHub = 1;
      this.txtShipment = '';
      this.ddlHub = '';
      this.$validator.reset();
      this.errors.clear();
    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8) {
          $event.preventDefault();
       }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/CargoShiftShipmentDestinationHub/CargoShiftShipmentDestinationHub.component.js